import { TextPlaceholder } from "./TextPlaceholder";
import { containerEvents } from "../../ContainerEvents";
import { CREATE_ENTITIES, graphicEvents } from "../../GraphicEvents";

export class TextEditionMode {

    constructor() {
        this.textPlaceholder = new TextPlaceholder('Mon texte', containerEvents.mouseCoords);
    }

    onFinishClick() {
        const text = this.textPlaceholder.getStatement();
        this.textPlaceholder.setup();

        graphicEvents.trigger(CREATE_ENTITIES, [text]);
    }

    onMoveMouse() {
        this.textPlaceholder.follow(containerEvents.mouseCoords);
    }

    destroy() {
        this.textPlaceholder.destroy();
    }
}